<template>
  <div :class="bem()">
    <a
      :href="buildInternalLink(item)"
      :class="bem('link')"
      @click="handleLinkClick"
    >
      <BaseHeading
        tag="h3"
        size="h3"
        :class="bem('title')"
      >
        {{ item.title }}
      </BaseHeading>
      <div
        :class="bem('image-container')"
      >
        <DynamicImage
          :image="item.image"
          :aspect-ratio="`3:4`"
          :class="bem('image')"
          :transform-widths="[500]"
          :sizes="[{ width: 500 }]"
          :lazy-load="true"
        />
      </div>
      <VisionButton
        :class="bem('button')"
        :button-text="item.cta"
        :outline="true"
        :background-colour="'black'"
        :element="'div'"
      />
    </a>
  </div>
</template>

<script setup>
const bem = useBEM('CenteredCarouselItem')
const { buildInternalLink } = useUrlBuilder()
const { $track } = useNuxtApp()

const props = defineProps({
  item: { type: Object, required: true },
  active: { type: Boolean, required: false, default: false},
  index: {type: Number, default: 0},
  parentTrackingId: {
    type: String,
    default: ''
  }
})

const emit = defineEmits([
  'active',
])

const colourArray = computed(() => {
  return (props.item.backgroundColours === 'image') ? props.item.imageColours.colors : props.item.customColours
})
  
async function handleLinkClick() {
  await $track.global.linkClicked({
    linkText: props.item.cta,
    interactionElement: props.item.trackingId || props.item.title,
    interactionSection: props.parentTrackingId,
    interactionCategory: 'Centered Carousel',
    position: props.index + 1
  }, 'Clicked Centered Carousel Item')
}

watch(() => props.active, async (newValue) => {
  if (newValue) {
    emit('active', colourArray)
  }
})
</script>

<style lang="postcss">
.CenteredCarouselItem {
  /* Cover the link with a pseudo */
  &:after {
    @apply content-[''] absolute block inset-0 cursor-pointer;
  }
}

.CenteredCarouselItem__link {
  @apply flex flex-col items-center justify-center gap-y-3;
}

.CenteredCarouselItem__title {
  @apply translate-y-10 text-center text-mid-grey transition-all duration-300 sm:duration-500;
}

.CenteredCarouselItem__button {
  @apply -translate-y-3 opacity-0 transition-all duration-500;
}

.CenteredCarouselItem__image-container {
  @apply px-8 aspect-[3/4] w-full flex items-center transition-[padding] duration-300;
}

.swiper-slide-active {
  .CenteredCarouselItem {
    /* Hide the link pseudo to reinstate click */
    &:after {
      @apply content-none;
    }
  }

  .CenteredCarouselItem__title {
    @apply translate-y-0 text-off-black;
  }

  .CenteredCarouselItem__button {
    @apply -translate-y-0 opacity-100 delay-100;
  }

  .CenteredCarouselItem__image-container {
    @apply px-0;
  }
}

.swiper-slide-next, .swiper-slide-prev {
  .CenteredCarouselItem__title {
    @apply text-grey-600;
  }
}
</style>
